import YesNoModalJ10 from '@aims/shared/components/YesNoModalJ10';
import { getQuarterLabel } from '@aims/shared/reports/quarters';
import { DeleteOutlined } from '@ant-design/icons';
import { gql, useMutation } from '@apollo/client';
import { Button, Divider, Typography, notification } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const deleteTrainingEventReportMutation = gql`
  mutation DeleteTrainingEventReportForUser($_id: ID!) {
    deleteTrainingEventReportForUser(_id: $_id) {
      deletedId
    }
  }
`;

const { Paragraph } = Typography;

function DeleteReportButton({ report }) {
  const [deleting, setDeleting] = useState();
  const onDelete = (o) => setDeleting(o);
  const onCancelDelete = () => setDeleting(undefined);

  const [loading, setLoading] = useState(false);
  const [deleteReport] = useMutation(deleteTrainingEventReportMutation);
  const history = useHistory();

  const onYes = useCallback(async () => {
    setLoading(true);
    try {
      await deleteReport({
        variables: {
          _id: report._id,
        },
      });
      notification.success({
        message: 'Deleted',
        description: 'Report deleted successfully',
      });
      history.push(`/training-reports/event`);
    } catch (err) {
      notification.error({
        message: 'Error',
        description: 'We apologize.  An error occurred.',
      });
      setLoading(false);
    }
  }, [report, deleteReport, history]);

  const locale = useSelector((store) => store.locale, shallowEqual);
  const dateFormat = useMemo(
    () =>
      new Intl.DateTimeFormat(locale, {
        dateStyle: 'medium',
      }),
    [locale],
  );
  const eventDate =
    report?.eventDate && dateFormat.format(new Date(report.eventDate));

  return (
    <>
      <YesNoModalJ10
        title="Delete Report Draft"
        yesText="Delete Report"
        noText="Cancel"
        onYes={onYes}
        onNo={onCancelDelete}
        visible={deleting}
        loading={loading}
      >
        <Paragraph>Are you sure you want to delete this report?</Paragraph>
        <Paragraph>{`${report?.eventAddress?.city}, ${report?.eventAddress?.country} ${eventDate}`}</Paragraph>
      </YesNoModalJ10>
      <div>
        <Divider />
        <div className="delete-box">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button onClick={onDelete} icon={<DeleteOutlined />} danger ghost>
              Delete Report
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeleteReportButton;
